import { render, staticRenderFns } from "./Parceria_botafogo.vue?vue&type=template&id=779bbd5b&scoped=true"
import script from "./Parceria_botafogo.vue?vue&type=script&lang=js"
export * from "./Parceria_botafogo.vue?vue&type=script&lang=js"
import style0 from "./Parceria_botafogo.vue?vue&type=style&index=0&id=779bbd5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779bbd5b",
  null
  
)

export default component.exports